import './inputs/musical_keyboard_input_macro_handler';
import './inputs/midi_control_change_input_macro_handler';
import './inputs/midi_button_input_macro_handler';
import './inputs/musical_keyboard_paged_octave_input_macro_handler';

import './outputs/musical_keyboard_output_macro_handler';
import './outputs/midi_control_change_output_macro_handler';
import './outputs/midi_button_output_macro_handler';
